<span
  class="ia-chip"
  [class.is-live]="status === 'live'"
  [class.is-upcoming]="status === 'upcoming'"
  [class.is-preview]="status === 'preview'"
  [class.is-closed]="status === 'closed'"
  [style.--ia-brand]="previewColor"
>
  <span class="ia-chip__dot" aria-hidden="true"></span>
  <span class="ia-chip__label">{{ labelKey | translate }}</span>
</span>
